// Content for Japanese locale
// This file contains all text content for future i18n support

// App Configuration
export const appConfig = {
  liffUrl: 'https://miniapp.line.me/2009616052-uI1ZOiQA',
};

export const content = {
  header: {
    logo: 'とりスタ',
    nav: {
      features: 'できること',
      howTo: '使い方',
      faq: 'よくある質問',
    },
  },
  hero: {
    title: '友達と会った記録をスタンプで集めよう！',
    tagline:
      'とりあえず、スタンプラリー。友達と実際に会ったときにQRコードをスキャンして、スタンプを集める楽しさ。',
    warning:
      '⚠️ 重要：このアプリはLINEアプリ内でのみ動作します。外部ブラウザでは一部機能が利用できません。',
    cta: {
      primary: '🚀 「とりスタ」をLINEで開く',
      secondary: '📖 使い方を見る',
    },
  },
  features: {
    title: 'できること',
    items: [
      {
        emoji: '🎫',
        title: 'スタンプを集める',
        description:
          'QRコードをスキャンして、友達と会った記録をスタンプで集めます。カレンダーで誰といつ会ったかが一目でわかります。',
      },
      {
        emoji: '🏆',
        title: 'ランキングで競争',
        description:
          '競争型とコレクション型の2つのモード。みんなの順位を見て競争したり、自分の記録を振り返ったりできます。',
      },
      {
        emoji: '📅',
        title: 'イベント期間',
        description: '期間限定イベントで特別なランキングに参加。過去のイベント記録も確認できます。',
      },
      {
        emoji: '👥',
        title: '友達を招待',
        description:
          '招待リンクで友達を招待。友達リストで承認済みの友達と、承認待ちのリクエストを確認できます。',
      },
    ],
  },
  howTo: {
    title: '使い方',
    steps: [
      {
        title: '「とりスタ」をLINEで開く',
        description: 'LINEアプリからとりスタを開きます',
      },
      {
        title: '友達を招待',
        description: '招待リンクを送って友達を招待します',
        shareButton: true,
      },
      {
        title: 'QRコードをスキャン',
        description: '友達と会ったらQRコードをスキャンします',
      },
      {
        title: 'スタンプゲット',
        description: 'スタンプを集めてカレンダーに記録されます',
      },
      {
        title: 'スタンプ帳を確認',
        description: '集めたスタンプをカレンダーで確認します',
      },
    ],
  },
  faq: {
    title: 'よくある質問',
    items: [
      {
        question: 'とりスタって何ですか？',
        answer:
          '友達と実際に会った記録をスタンプで集めるLINEミニアプリです。QRコードをスキャンして、友達との思い出を楽しく記録できます。',
      },
      {
        question: 'どうやって使うの？',
        answer:
          'LINEアプリから開いて、友達を招待します。友達と会ったときにQRコードをスキャンすると、スタンプが記録されます。',
      },
      {
        question: 'スタンプはどうやって集めるの？',
        answer:
          '友達のQRコードをスキャンするか、友達にあなたのQRコードをスキャンしてもらうことでスタンプを集められます。',
      },
      {
        question: 'ランキングはどうやって決まるの？',
        answer:
          '集めたスタンプの数でランキングが決まります。競争型モードでは全員のランキングが表示され、コレクション型では自分の記録を振り返れます。',
      },
      {
        question: '友達を招待するには？',
        answer:
          'アプリ内の招待リンクをLINEで送信します。友達がリンクをタップしてアプリを開くと、友達リクエストが送信されます。',
      },
    ],
  },
  slideshow: {
    title: '画面プレビュー',
    slides: [
      {
        title: 'カレンダー画面',
        description: '友達と会った日付をカレンダーで確認できます',
      },
      {
        title: 'ランキング画面',
        description: '友達とのスタンプ数を比較して競います',
      },
      {
        title: 'スタンプコレクション画面',
        description: '収集したスタンプを一覧で確認できます',
      },
    ],
  },
  tips: {
    title: 'ヒント',
    items: [
      {
        title: '毎日チェック',
        description: 'カレンダーを毎日チェックして、友達との思い出を振り返りましょう。',
      },
      {
        title: '友達を増やそう',
        description: 'たくさんの友達を招待して、スタンプコレクションを充実させましょう。',
      },
      {
        title: 'イベントに参加',
        description: '期間限定イベントに参加して、特別なランキングを楽しみましょう。',
      },
      {
        title: 'ランキングを競争',
        description: '友達とランキングを競い合って、モチベーションを高めましょう。',
      },
    ],
  },
  roadmap: {
    title: '今後の予定',
    items: [
      'スタンプのデザインカスタマイズ機能',
      'グループでのスタンプラリー機能',
      '達成バッジとトロフィーシステム',
      '友達との思い出メモ機能',
      'スタンプの統計とグラフ表示',
    ],
  },
  footer: {
    links: {
      contact: 'お問い合わせ',
      privacy: 'プライバシーポリシー',
      terms: '利用規約',
    },
    copyright: '© 2026 とりスタ. All rights reserved.',
  },
};

export type Content = typeof content;
